import { motion } from "framer-motion";
import {
  Sparkles, Camera, Megaphone, Palette
} from "lucide-react";

const services = [
  { icon: Sparkles, title: "Social Media Management & Digital Strategy", desc: "Gestiamo la tua presenza su Facebook e TikTok: strategia, community, analisi di mercato e competitor, piano su misura con KPI chiari.", tid: "svc-social" },
  { icon: Camera, title: "Content Creation", desc: "Foto, reel e storie girati direttamente nel tuo punto vendita, con montaggi in stile trend e copertine coordinate.", tid: "svc-content" },
  { icon: Megaphone, title: "Meta & TikTok Advertising", desc: "Campagne locali e nazionali ottimizzate per portare traffico, prenotazioni e vendite reali al tuo brand.", tid: "svc-ads" },
  { icon: Palette, title: "Branding, Press Office & Eventi", desc: "Identità visiva, ufficio stampa e promozione di eventi: logo, palette, media giusti al momento giusto e community management pre e post evento.", tid: "svc-branding" },
];

const parent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};
const child = {
  hidden: { y: 24, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 0.7, ease: [0.2, 0.7, 0.2, 1] } },
};

export default function Servizi() {
  return (
    <section id="servizi" data-testid="section-servizi" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-purple-300/80 mb-4">01 · Servizi</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[0.95]">
              Un'agenzia. <br />Tutto ciò che serve <br />al tuo <span className="text-gradient">brand</span>.
            </h2>
          </div>
          <p className="max-w-md text-slate-400 text-base md:text-lg">
            Dalla strategia al singolo reel: curiamo ogni tassello della tua comunicazione digitale
            per trasformare l'attenzione online in valore reale.
          </p>
        </div>

        <motion.div
          variants={parent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                variants={child}
                whileHover={{ y: -8 }}
                data-testid={s.tid}
                className="tilt glass gradient-border rounded-3xl p-7 md:p-8 flex flex-col gap-5 min-h-[240px]"
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 border border-white/10 text-purple-300">
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <div>
                  <div className="text-xs font-medium text-purple-300/80 mb-1">0{i + 1}</div>
                  <h3 className="font-display text-xl md:text-2xl text-white leading-snug">{s.title}</h3>
                </div>
                <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
